import { faSeedling, faUmbrellaBeach } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AppLink from "components/common/AppLink";
import HTMLCode from "components/common/HTMLCode";
import If from "components/common/If";
import { AppRoutes } from "config/router";
import { Roles } from "utilities/app-utilities";
import useAppContext from "utilities/hooks/useAppContext";

const Dashboard = () => {
    const context = useAppContext();

    const linkWrapperClassName = "border theme-border";

    const linkClassName = "block p-5 text-center";

    return (
        <div className="flex justify-center items-center h-vh-70 p-5">
            <div className="text-center">
                <div className="pb-10">
                    <h1>Welcome to the <span className="text-primary">Sunrise.House</span></h1>
                    <p>Choose an option below to get started</p>
                </div>
                <div className={linkWrapperClassName}>
                    <If condition={context.userContainsRoles([Roles.AGRICULTURE_SALES_READ, Roles.AGRICULTURE_WORK_READ])}>
                        <AppLink className={linkClassName} to={AppRoutes.AGRICULTURE_OVERVIEW}>
                            <FontAwesomeIcon icon={faSeedling} />
                            <HTMLCode />
                            <HTMLCode />
                            <span>Go to agriculture</span>
                        </AppLink>
                    </If>
                </div>
                <div className={`${linkWrapperClassName} mt-5`}>
                    <If condition={context.userContainsRoles([Roles.ACCOMMODATION_BOOKINGS_READ, Roles.ACCOMMODATION_WORK_READ])}>
                        <AppLink className={linkClassName} to={AppRoutes.ACCOMMODATION_OVERVIEW_HOME}>
                            <FontAwesomeIcon icon={faUmbrellaBeach} />
                            <HTMLCode />
                            <HTMLCode />
                            <span>Go to accommodation</span>
                        </AppLink>
                    </If>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;
